import React, { useState, useEffect, useContext } from 'react';
import './documents.scss';
import { Button, LoadingScreen } from 'components';
import { LendingContext } from 'context';
import { useNavService } from 'hooks';
import { routes } from 'router';
import { finaliseApiCall, TealiumService } from 'services';
import { OmfLogo, BackArrowDark } from 'assets';

const REQUIRED_DOCS = [
  'Your green bar coded ID or ID Card',
  '3 months bank statements',
  'Most recent Payslip or Salary Advice',
];

export const Documents = () => {
  const navigate = useNavService();
  const { application } = useContext(LendingContext);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
    TealiumService.onDocumentsStart(omfOffer, application?.offers?.hashId);
  }, []);

  async function handleSubmit() {
    if (submitting) { return; }

    const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
    TealiumService.onDocumentsSubmit(omfOffer, application?.offers?.hashId);

    setSubmitting(true);
    try {
      const response = await finaliseApiCall();
      if (response?.status < 400) {
        navigate.to(routes.applicationSubmitted);
      } else {
        navigate.to(routes.appFailed);
      }
    } catch {
      navigate.to(routes.appFailed);
    } finally {
      setSubmitting(false);
    }
  }

  if (submitting) {
    return (
      <LoadingScreen
        loadingMessage='Submitting application'
        secondaryMessage='This should only take a moment'
      />
    );
  }

  return (
    <section className='documents-page'>
      <header className='documents-header'>
        <button
          className='documents-header__back'
          onClick={() => navigate.back()}
          aria-label='Go back'
        >
          <img src={BackArrowDark} alt='Back' />
        </button>
        <h1 className='documents-header__title'>Documents</h1>
      </header>

      <main className='documents-content'>
        <div className='documents-panel'>
          <h2 className='documents-panel__heading'>Documentation required</h2>

          <p className='documents-panel__text'>
            One of our consultants will contact you in the next 24 hours.
          </p>

          <p className='documents-panel__text'>
            For a quick and easy call, please have the following documents ready to send to us:
          </p>

          <ul className='documents-checklist'>
            {REQUIRED_DOCS.map((doc) => (
              <li key={doc} className='documents-checklist__item'>
                <span className='documents-checklist__icon' aria-hidden='true' />
                <span className='documents-checklist__label'>{doc}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className='documents-footer-area'>
          <Button primary onClick={handleSubmit} className='documents-submit'>
            Submit application
          </Button>

          <div className='documents-branding'>
            <img src={OmfLogo} alt='In association with Old Mutual Finance' className='documents-branding__omf-logo' />
          </div>
        </div>
      </main>
    </section>
  );
};
